"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInflatedIdAncestorChain = exports.hasFakeInflation = exports.getInflatedIdsKeys = exports.inflateMultiSharedPartCompIds = exports.inflateSharedPartCompId = exports.deflateMultiSharedPartCompIds = exports.deflateSharedPartCompId = exports.saveInflatedIdToMaps = exports.isInflatedId = exports.isRefComponent = exports.getRefCompIdsFromInflatedId = exports.getTemplateFromInflatedId = exports.getMultipleRefCompsIdFromInflatedId = exports.getRefCompIdFromInflatedId = exports.replaceSharedPartsPrefix = exports.hasSharedPartsPrefix = exports.fixSharedPartsIds = exports.removeSharedPartsPrefix = exports.getUniqueId = exports.SHARED_PARTS_PREFIX = exports.REF_DELIMITER = exports.GHOST_COMP_TYPE = void 0;
const SHARED_PART_COMP_ID_TO_INFLATED_ID = {};
const SHARED_PART_INFLATED_ID_TO_COMP_ID = {};
exports.GHOST_COMP_TYPE = 'GhostComp';
exports.REF_DELIMITER = '_r_';
exports.SHARED_PARTS_PREFIX = 'sharedParts';
const getUniqueId = (refId, originalId) => `${refId}${exports.REF_DELIMITER}${originalId}`;
exports.getUniqueId = getUniqueId;
const removeSharedPartsPrefix = (id) => id.replace(`${exports.SHARED_PARTS_PREFIX}${exports.REF_DELIMITER}`, '');
exports.removeSharedPartsPrefix = removeSharedPartsPrefix;
const fixSharedPartsIds = (id) => `${exports.SHARED_PARTS_PREFIX}${exports.REF_DELIMITER}${id}`;
exports.fixSharedPartsIds = fixSharedPartsIds;
const hasSharedPartsPrefix = (id) => id.split(exports.REF_DELIMITER)[0] === exports.SHARED_PARTS_PREFIX && id.split(exports.REF_DELIMITER).length >= 2;
exports.hasSharedPartsPrefix = hasSharedPartsPrefix;
function replaceSharedPartsPrefix(str, replacement) {
    return str.replace(exports.SHARED_PARTS_PREFIX, replacement);
}
exports.replaceSharedPartsPrefix = replaceSharedPartsPrefix;
const getRefCompIdFromInflatedId = (id) => {
    if ((0, exports.hasSharedPartsPrefix)(id)) {
        return id;
    }
    return id.split(`${exports.REF_DELIMITER}`)[0];
};
exports.getRefCompIdFromInflatedId = getRefCompIdFromInflatedId;
// Will give different result than getRefCompIdFromInflatedId()
// in case of widget-in-widget. for example:
// id='firstRefComp_r_secondRefComp_r_innerCompId' -> return 'firstRefComp_r_secondRefComp'
const getMultipleRefCompsIdFromInflatedId = (id) => {
    const isSharedPart = (0, exports.hasSharedPartsPrefix)(id);
    const refCompId = isSharedPart ? (0, exports.removeSharedPartsPrefix)(id) : id;
    const multipleRefCompsIdFromInflatedId = refCompId.substring(0, refCompId.lastIndexOf(`${exports.REF_DELIMITER}`)) || id;
    return isSharedPart ? (0, exports.fixSharedPartsIds)(multipleRefCompsIdFromInflatedId) : multipleRefCompsIdFromInflatedId;
};
exports.getMultipleRefCompsIdFromInflatedId = getMultipleRefCompsIdFromInflatedId;
const getTemplateFromInflatedId = (id) => (0, exports.removeSharedPartsPrefix)(id).split(exports.REF_DELIMITER).pop();
exports.getTemplateFromInflatedId = getTemplateFromInflatedId;
const getRefCompIdsFromInflatedId = (id) => (0, exports.getMultipleRefCompsIdFromInflatedId)(id).split(`${exports.REF_DELIMITER}`);
exports.getRefCompIdsFromInflatedId = getRefCompIdsFromInflatedId;
const isRefComponent = (component) => component?.componentType.endsWith('RefComponent');
exports.isRefComponent = isRefComponent;
function isInflatedId(id) {
    return (0, exports.removeSharedPartsPrefix)(id).includes(exports.REF_DELIMITER);
}
exports.isInflatedId = isInflatedId;
function saveInflatedIdToMaps(compId, inflatedId) {
    const previousInflatedId = SHARED_PART_COMP_ID_TO_INFLATED_ID[compId];
    if (compId === inflatedId || previousInflatedId === inflatedId) {
        return;
    }
    if (previousInflatedId) {
        delete SHARED_PART_INFLATED_ID_TO_COMP_ID[previousInflatedId];
    }
    SHARED_PART_COMP_ID_TO_INFLATED_ID[compId] = inflatedId;
    SHARED_PART_INFLATED_ID_TO_COMP_ID[inflatedId] = compId;
}
exports.saveInflatedIdToMaps = saveInflatedIdToMaps;
const deflateSharedPartCompId = (compId) => {
    return SHARED_PART_INFLATED_ID_TO_COMP_ID[compId] || compId;
};
exports.deflateSharedPartCompId = deflateSharedPartCompId;
const deflateMultiSharedPartCompIds = (compIds) => compIds?.map((compId) => (0, exports.deflateSharedPartCompId)(compId));
exports.deflateMultiSharedPartCompIds = deflateMultiSharedPartCompIds;
const inflateSharedPartCompId = (compId) => {
    return SHARED_PART_COMP_ID_TO_INFLATED_ID[compId] || compId;
};
exports.inflateSharedPartCompId = inflateSharedPartCompId;
const inflateMultiSharedPartCompIds = (compIds) => compIds?.map((compId) => (0, exports.inflateSharedPartCompId)(compId));
exports.inflateMultiSharedPartCompIds = inflateMultiSharedPartCompIds;
const getInflatedIdsKeys = (refId) => {
    return Object.keys(SHARED_PART_INFLATED_ID_TO_COMP_ID).filter((compId) => compId.endsWith(refId));
};
exports.getInflatedIdsKeys = getInflatedIdsKeys;
const hasFakeInflation = (compId) => SHARED_PART_COMP_ID_TO_INFLATED_ID.hasOwnProperty(compId);
exports.hasFakeInflation = hasFakeInflation;
const getInflatedIdAncestorChain = (itemId) => {
    const inflatedIdAncestorChain = [];
    itemId
        .split(exports.REF_DELIMITER)
        .reverse()
        .forEach((item, index) => index === 0
        ? inflatedIdAncestorChain.push(item)
        : inflatedIdAncestorChain.push((0, exports.getUniqueId)(item, inflatedIdAncestorChain[index - 1])));
    return inflatedIdAncestorChain.reverse();
};
exports.getInflatedIdAncestorChain = getInflatedIdAncestorChain;
//# sourceMappingURL=refUtils.js.map